import React, { ChangeEvent, useState } from "react";
import { ReactComponent as BimatterLogo } from "./styles/Images/bimatter_logo.svg";
import classes from "./styles/DemoPage.module.css";
import DemoViewer from "../components/Viewer/DemoViewer";
import { useNavigate } from "react-router-dom";
import MenuButton from "../components/Buttons/MenuButton";
function DemoPage() {
    const demoModels = {
        ar: ["FileSystem/Demo/Clinic_Ar.min.bmt"],
        kr: ["FileSystem/Demo/Clinic_Kr.min.bmt"],
        ios: ["FileSystem/Demo/Clinic_Ios.min.bmt"],
        full: [
            "FileSystem/Demo/Clinic_Ar.min.bmt",
            "FileSystem/Demo/Clinic_Kr.min.bmt",
            "FileSystem/Demo/Clinic_Ios.min.bmt",
        ],
    };
    const navigate = useNavigate();
    const [curModel, setCurModel] = useState<
        keyof typeof demoModels | FileList | null
    >(null);
    const loadModel = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.accept = ".bmt, .ifc";
        document.body.appendChild(input);
        input.click();
        input.onchange = (e) => {
            const files = (e.target as HTMLInputElement)!.files;
            input.remove();
            setCurModel(files!);
        };
    };
    if (!curModel) {
        return (
            <div className={classes.wrap}>
                <div className={classes.modal}>
                    <BimatterLogo
                        className={classes.bimatter_logo}
                    ></BimatterLogo>
                    <div>Demo version</div>
                    <div className={classes.button_top_wrap}>
                        <MenuButton
                            className={classes.button}
                            onClick={() => {
                                setCurModel("ar");
                            }}
                        >
                            AR
                        </MenuButton>
                        <MenuButton
                            className={classes.button}
                            onClick={() => {
                                setCurModel("kr");
                            }}
                        >
                            KR
                        </MenuButton>
                        <MenuButton
                            className={classes.button}
                            onClick={() => {
                                setCurModel("ios");
                            }}
                        >
                            IOS
                        </MenuButton>
                    </div>
                    <div className={classes.button_bot_wrap}>
                        <MenuButton
                            className={classes.button}
                            onClick={() => {
                                setCurModel("full");
                            }}
                        >
                            Full model
                        </MenuButton>
                    </div>
                    <div className={classes.sep}></div>
                    <div className={classes.button_bot_wrap}>
                        <MenuButton
                            className={classes.button}
                            onClick={loadModel}
                        >
                            Fast load ifc
                        </MenuButton>
                        <MenuButton
                            className={classes.button}
                            onClick={() => {
                                navigate("/files");
                            }}
                        >
                            File system
                        </MenuButton>
                    </div>
                </div>
            </div>
        );
    }
    if (curModel instanceof FileList) {
        return <DemoViewer files={curModel} />;
    } else {
        return <DemoViewer model_paths={demoModels[curModel]} />;
    }
}

export default DemoPage;
